import classNames from 'clsx'
import { bool, node, number, string } from 'prop-types'
import { useEffect, useRef, useState } from 'react'

import { TENANT_CH } from 'shared/consts'
import {
  FILTER_FLYOUT_CLOSE,
  FILTER_FLYOUT_OPEN,
} from 'shared/experiments/components/NewSerp/consts'
import store, { subscribe } from 'shared/store'
import Button from 'views/components/atoms/Button'
import IconCaretDown from 'views/components/atoms/Icon/IconCaretDown'
import IconCaretUp from 'views/components/atoms/Icon/IconCaretUp'

import { lockContentHeight } from './helpers'

import './FlyoutFilter.scss'

const FlyoutFilter = ({
  children,
  attribute,
  label,
  active,
  hidden,
  count,
  tenant,
}) => {
  const flyoutRef = useRef(null)
  const [expanded, setFilterExpanded] = useState(false)
  const [isHeightLocked, setHeightIsLocked] = useState(false)

  const hide = () => setFilterExpanded(false)

  const handleOverlayClick = event => {
    /** @var {HTMLElement} */
    const targetElement = event.target

    if (
      !targetElement.closest('.e-FlyoutFilter') &&
      !targetElement.contains(document.activeElement) &&
      // SVG has issues with `contains` method
      !['svg', 'path'].includes(targetElement.tagName.toLowerCase())
    ) {
      hide()
      store.dispatch({ type: FILTER_FLYOUT_CLOSE, attribute })
      document.removeEventListener('click', handleOverlayClick)
    }
  }

  const handleButtonClick = () => {
    const newExpandedValue = !expanded

    store.dispatch({
      type: newExpandedValue ? FILTER_FLYOUT_OPEN : FILTER_FLYOUT_CLOSE,
      attribute,
    })
    setFilterExpanded(newExpandedValue)
    if (newExpandedValue && !isHeightLocked) {
      lockContentHeight(flyoutRef.current, () => setHeightIsLocked(true))
    }

    document.addEventListener('click', handleOverlayClick)
  }

  useEffect(() => {
    return subscribe.after(FILTER_FLYOUT_CLOSE, hide)
  }, [])

  return (
    <div
      ref={flyoutRef}
      className={classNames('e-FlyoutFilter', {
        'u-hidden': hidden,
      })}
    >
      <Button
        onClick={handleButtonClick}
        name={label}
        style="buttonFilter"
        className={classNames('e-FlyoutFilter__button', {
          'e-FlyoutFilter__button--active': active,
          'e-FlyoutFilter__button--expanded': expanded,
        })}
      >
        <span className="e-FlyoutFilter__label a-truncate-with-ellipsis">
          {label}
        </span>
        {Boolean(active && count) && (
          <span className="e-FlyoutFilter__count u-margin-small--left u-background-color--blue u-color--white">
            {count}
          </span>
        )}
        {expanded ? (
          <IconCaretUp
            size="small"
            className="u-margin-xx-small--left e-FlyoutFilter__icon"
          />
        ) : (
          <IconCaretDown
            size="small"
            className="u-margin-xx-small--left e-FlyoutFilter__icon"
          />
        )}
      </Button>
      <div
        className={classNames('e-FlyoutFilter__flyout', {
          'e-FlyoutFilter--expanded': expanded,
        })}
      >
        <div
          className={classNames('e-FlyoutFilter__flyout--content', {
            'e-FlyoutFilter__flyout--content--ch': tenant === TENANT_CH,
          })}
        >
          {children}
        </div>
      </div>
    </div>
  )
}

FlyoutFilter.propTypes = {
  attribute: string.isRequired,
  label: string.isRequired,
  children: node.isRequired,
  active: bool,
  hidden: bool,
  count: number,
  tenant: string,
}

FlyoutFilter.defaultProps = {
  active: false,
  hidden: false,
  count: null,
}
export default FlyoutFilter
